import { createSelector } from 'reselect';
import enums from '../../../constants/enums';

const getTransactions = state => state.ledger.transactions;

export const getLedgers = createSelector(
  getTransactions,
  (transactions) => {
    const map = {
      currency: {},
      accountCurrency: {},
      account: {},
      all: {
        all: {
          title: 'All Transactions',
          transactions: transactions,
        }
      }
    };
    if(transactions) {

      transactions.forEach(transaction => {
        const accountCurrencyKey = `${transaction.account}-${transaction.currency}`;
        const account = enums.accountByValue[transaction.account];
        const accountName = account ? account.label : transaction.account;

        if (!map.accountCurrency[accountCurrencyKey]) {
          map.accountCurrency[accountCurrencyKey] = {
            title: `${accountName} - ${transaction.currency}`,
            transactions: [],
            total: 0,
            currency: transaction.currency,
          };
        }
        if (!map.currency[transaction.currency]) {
          map.currency[transaction.currency] = {
            title: `${transaction.currency}`,
            transactions: [],
            total: 0,
            currency: transaction.currency,
          };
        }
        if (!map.account[transaction.account]) {
          map.account[transaction.account] = {
            title: `${transaction.account}`,
            transactions: [],
            total: 0,
          };
        }
        map.accountCurrency[accountCurrencyKey].transactions.push(transaction);
        map.accountCurrency[accountCurrencyKey].total += transaction.amount;

        map.currency[transaction.currency].transactions.push(transaction);
        map.currency[transaction.currency].total += transaction.amount;

        map.account[transaction.account].transactions.push(transaction);
      });
    }
    return map;
  },
);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/Ledger.selector.js